import { get } from '@kit/utils/APIV1.js'

export const star = async(_id) => {
  return get('star')
}

export const starEvents = async(_id) => {
  return get('star-events')
}